module.exports = __webpack_public_path__ + "static/media/musementLogo.b9e88a90.png";